import semver from "semver";

const sessionCouldHaveOldTaggingData = function(sessionContentsOrVersion, schemaRef) {
    return semver.valid(sessionContentsOrVersion)
        || sessionContentsOrVersion === 0; // AK - some sessions have SessionSchema set to 0
};

export default sessionCouldHaveOldTaggingData;